<template>
<div class="task" ref="task">
		<div class="top-image">
            <div class="image">
			    <img :src="session.background_url" v-if="session.background_url">
                <van-button @click="download" v-if="pdf_url" ><van-icon name="back-top" style="transform: rotate(180deg);"/>下载PDF</van-button>
            </div>
		</div>
        <div class="name">
            <b v-if="userInfo.realname" class="name">{{userInfo.writer_name}}</b>
        </div>
        <div class="main" v-for="(val,key) in schedule" :key="key">
            <div class="line">{{key}}</div>
            <div class="schedule">
                <div v-for="(item,index) in val" :key="index">
                <h3>{{item.session_name}}</h3>
                <div class="detail">
                <div class="left">
                    <p v-if="item.detail_start_at">{{formatTime(item.detail_start_at)}}-{{formatTime(item.detail_end_at)}}</p>
                    <p v-else>{{formatTime(item.chapter_start_at)}}-{{formatTime(item.chapter_end_at)}}</p>
                </div>
                <div class="right1">
                    <p><b>{{item.chapter_name}}</b><b v-if="item.detail_name">--{{item.detail_name}}</b></p>
                    <p>{{item.title}}</p>
                    <p v-if="item.zoom_set">zoom会议号：{{item.zoom_set.url}}</p>
                    <span v-if="item.zoom_set">zoom登录密码：{{item.zoom_set.password}}</span> 
                    <img src="../../assets/images/System/up.png" @click="changeShow(key,index)" v-if="showList[key][index]&&item.about.length>0">
                    <img src="../../assets/images/System/down.png" @click="changeShow(key,index)" v-else-if="item.about.length>0">
                </div>
                </div>
               
                <table class="more" v-if="showList[key][index]==true">
                        <tr  v-for="(val,index) in item.about" :key="index">
                            <td><span class="nowrap" style="background:gray;color:white;padding:5px;">{{formatTime(val.start_at)}}-{{formatTime(val.end_at)}}</span></td>
                            <td>
                                <p style="padding-left:10px;">{{val.name}}</p>
                                <p style="color: rgb(69, 69, 228);padding-left:10px;"><span v-for="(item,index) in val.writers" :key="index">{{item.name}}&nbsp;&nbsp;</span></p>
                            </td>
                        </tr>
                </table>
                <div class="thick-line"></div>
                 </div>
                 
            </div>
        </div>
        <van-popup v-model="showFlag" :close-on-click-overlay="false" style="width:90%;max-width:800px;" round>
            <img :src="banner_url" style="width:100%" v-if="meeting_id"/>
            <img src="../../assets/images/sec_banner.jpeg" style="width:100%" v-else/>
            <p style="padding:0 10px;line-height:26px;font-size:15px;">尊敬的专家，您好</p>
            <p style="padding:0 10px;line-height:26px;font-size:15px;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;请您输入您的手机号码，来进入的您日程查询页面，此页面包含线上ZOOM登录信息，仅供您本人进行查阅及参考，请您务必不要分享给到他人，谢谢您。</p>
            <p style="padding:0 10px;line-height:26px;font-size:15px;text-align:right;">会务组</p>
            <van-form @submit="onSubmit" style="margin-top:10px;">
                <van-field 
                label="手机号"
                placeholder="请输入您的手机号"
                v-model="mobile"
                 :rules="[{ required: true, message: '请填写手机号' }]"/>
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit" color="#d2020d" :loading="loading" :disabled="loading==true">
                        确定
                    </van-button>
                </div>
            </van-form>

        </van-popup>
</div>
</template>
<script>
	import {mobileSchedule,MeetingsDetails} from '../../config/interface.js'
    export default{
		data(){
			return{
				userInfo:'',  //用户信息
                session:{},
                schedule:{},
                showList:[],
                show:false,
                mobile:'',
                pdf_url:'',
                showFlag:true,
                loading:false,
                meeting_id:0,
                banner_url:''
			}
		},
        watch: {
                showList: {
                handler: function(newVal,old) {
                    //do something
                    // console.log(newVal,old)
                },
                    deep: true
                }
        },
		mounted(){
            this.meeting_id = this.$route.query.meeting_id;
            if(this.meeting_id){
                this.getMeetingCarousel();
            }
		},
		methods:{
            onSubmit(){
                this.getSchedule();
            },
            //会议轮播
			getMeetingCarousel(){
				const url=MeetingsDetails;
				let params={
					meeting_id:this.meeting_id
				}
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.banner_url=data.banner;
					}
				})
			},
            //获取信息
			getSchedule(){
                this.loading=true;
				const url=mobileSchedule;
				const method='POST'
				let params={
                    mobile:this.mobile,
                    meeting_id:this.meeting_id
                };
				fetch(url,params,method)
				.then((res)=>{
                    this.loading=false;
					if(res.code==0){
                        this.showFlag=false;
						this.schedule=res.data['schedules'];
                        this.session=res.data.mission_set;
                        this.pdf_url=res.data.pdf_url;
                        this.showList={};
                        for(let key in this.schedule){
                            this.showList[key]=[];
                            for(let j=0;j<this.schedule[key].length;j++){
                                this.showList[key].push(false);
                            }
                        }
					}
                    else{
                        common.toast( res && res.error_msg ? res.error_msg : "未知错误",1000,'fail',()=>{})
                    }
				})
			},
            formatTime(str){
                if(str){
                    str=str.slice(11,16);
                }
                return str;
            },
            changeShow(key,index){
                let list=[];
                for(let i=0;i<this.showList[key].length;i++){
                    if(i==index){
                        list.push(!this.showList[key][i])
                    }
                    else{
                        list.push(this.showList[key][i])
                    }
                }
                this.$delete(this.showList,key);
                this.$set(this.showList,key,list);
            },
            download(){
                 window.open(this.pdf_url);
            }
		}
	}
</script>
<style lang="scss" scoped>
.task{
    margin: 10px;
    padding-bottom: 10px;
    background: white;
    font-family:"Microsoft YaHei",Arial,Helvetica,sans-serif,"SimSun";
    .top-image{
        width:100%;
        padding:0;
        margin:0;
        img{
            width: 100%;
        }
        .image{
            position: relative;
            .van-button{
                position:absolute;
                background-color:transparent;
                color: white;
                border: 0;
                top:0;
                right:0;
            }
        }
    }
    .name{
        padding-left: 3px;
        background: $color-main;
        color: white;
        line-height: 20px;
        font-size:12px ;
        /deep/ b{
            font-size:14px ;
        }
    }
    .welcome{
        line-height: 24px;
        padding:10px;
        
    }
    .main{
        margin-top:20px;
        margin-bottom:0 ;
        .line{
            padding-left: 3px;
            background: $color-main;
            color: white;
            line-height: 20px; 
            width:100%;
            height: 20px; 
            font-size: 14px;
        }
        .thick-line{
            height: 1px;
            width:100%;
            background: rgb(253, 219, 219);
            margin:10px auto;
        }
        .schedule{
            background:white ;
            padding:10px;
            line-height: 24px;
            font-size: 12px;
            .detail{
                display: flex;
                .left{
                    display: inline-block;
                    width:80px;
                    p{
                        width:80px;
                        white-space:nowrap
                    }
                }
                .right1{
                    margin-left:8px;
                    width: calc(100% - 88px);
                    img{
                        float:right;
                        width:14px;
                    }

                }
            }
            .more{
                    .nowrap{
                        overflow:hidden; //超出的文本隐藏
                        text-overflow:ellipsis; //溢出用省略号显示
                        white-space:nowrap; //溢出不换行 （只显示一行）
                    }
                    td{
                        vertical-align: top;
                    }
                    text-align: left;
                    margin-top:10px ;
                    margin-bottom:10px;
                }
            
        }
    }
    .tips{
        line-height: 24px;
        padding:10px;
    }
    .bottom-qrcode{
        display: flex;
        justify-content: space-around;
        .qrcode{
            width: 40%;
            text-align: center;
            /deep/ img{
                width:100%;
            }
        }

    }
    .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 80%;
    height: 120px;
    background-color: #fff;
    padding: 10px;
    text-align: center;
    p{
        font-size:14px ;
    }
    .van-field{
        border-width:1px;
    }
    .van-button{
        text-align: center;
        background: $color-main;
        color: white;
        margin-top:10px ;
    }
  }
}
/deep/.van-cell{
    font-size: 19px;;
}
</style>


// WEBPACK FOOTER //
// src/pages/Expert/codeSchedule.vue